module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "lass": "t-index"
    }
  }, [_c('div', {
    staticClass: "home-header"
  }, [_c('div', {
    staticClass: "header-main content"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/headtitle.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-search"
  }, [_c('div', {
    staticClass: "input-text"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    staticClass: "form-control dropdown-toggle",
    attrs: {
      "type": "text",
      "data-toggle": "dropdown",
      "placeholder": "请输入您要搜索的内容",
      "aria-expanded": "false"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.openSearch.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.openSearch
    }
  }, [_vm._v("搜 索")])])]), _vm._v(" "), _c('div', {
    staticClass: "hotsearch",
    on: {
      "click": function($event) {
        return _vm.openNewPag('https://www.gdzwfw.gov.cn/portal/v2/guide/11440106MB2C79403T4440705001000')
      }
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main g-main"
  }, [_c('div', {
    staticClass: "outcont",
    attrs: {
      "id": "yytxq"
    }
  }, [_c('div', {
    staticClass: "container service"
  }, [_c('div', {
    staticClass: "title title01"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "one-cont"
  }, [_c('div', {
    staticClass: "cont-theme cont1"
  }, [_c('div', {
    staticClass: "subject-list"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.gerenTheme.themeList), function(item, index) {
    return _c('div', {
      class: [index == 0 ? 'item active' : 'item']
    }, [_c('div', {
      staticClass: "title"
    }, [_c('img', {
      attrs: {
        "src": item.icon
      }
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      class: [index == 0 ? 'index index-active' : 'index index-normal']
    }, [_vm._v(_vm._s(index + 1))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "two-cont"
  }, _vm._l((_vm.gerenTheme.themeList), function(item1, index1) {
    return _c('div', {
      staticClass: "cont service-cont"
    }, [_c('div', {
      staticClass: "service-list"
    }, [_c('div', {
      staticClass: "swiper list-swiper"
    }, [_c('div', {
      staticClass: "swiper-wrapper"
    }, [_c('div', {
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "service-table"
    }, [_c('div', {
      staticClass: "service-body"
    }, [_vm._l((item1.itemList.slice(_vm.pageSize * (_vm.currentPage_gr[index1] - 1), _vm.pageSize * (_vm.currentPage_gr[index1]))), function(item2, index2) {
      return _c('div', {
        staticClass: "service-item"
      }, [_c('div', [_c('a', {
        attrs: {
          "target": "_blank",
          "href": item2.itemUrl
        }
      }, [_vm._v(_vm._s(index2 + 1) + "    " + _vm._s(item2.itemName))])]), _vm._v(" "), _c('div', {
        class: [item2.lbsjdUrl ? 'lbsjd-active' : 'lbsjd-normal'],
        on: {
          "click": function($event) {
            return _vm.openNewPage(item2.lbsjdUrl)
          }
        }
      }, [_vm._v("\"路标式\"解读")]), _vm._v(" "), _c('div', [_c('a', {
        attrs: {
          "target": "_blank",
          "href": item2.bsznUrl
        }
      }, [_vm._v("办事指南")]), _vm._v(" "), (item2.ermIcon) ? _c('el-popover', {
        attrs: {
          "placement": "bottom",
          "trigger": "hover",
          "visible-arrow": false,
          "popper-options": {
            boundariesElement: 'body',
            removeOnDestroy: true
          }
        }
      }, [_c('div', {
        staticClass: "service-item-ewm"
      }, [_c('img', {
        attrs: {
          "src": item2.ermIcon
        }
      }), _vm._v(" "), _c('div', [_vm._v("使用微信扫码登录")])]), _vm._v(" "), _c('el-button', {
        attrs: {
          "slot": "reference",
          "type": "text"
        },
        slot: "reference"
      }, [_vm._v("手机办理")])], 1) : _c('a', {
        attrs: {
          "target": "_blank",
          "href": item2.sjblUrl
        }
      }, [_vm._v("手机办理")]), _vm._v(" "), _c('a', {
        attrs: {
          "target": "_blank",
          "href": item2.zxblUrl
        }
      }, [_vm._v("在线办理")])], 1)])
    }), _vm._v(" "), (item1.itemList.length > _vm.pageSize) ? _c('el-pagination', {
      attrs: {
        "prev-text": "上一页",
        "next-text": "下一页",
        "total": item1.itemList.length,
        "current-page": _vm.currentPage_gr[index1],
        "page-size": _vm.pageSize,
        "layout": "prev, pager, next"
      },
      on: {
        "current-change": function($event) {
          return _vm.handlePageChange($event, index1, 'gr')
        }
      }
    }) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
      staticClass: "swiper-pagination swiper-pagination1"
    })])]), _vm._v(" "), (item1.chainItemList) ? _c('div', {
      staticClass: "onedo"
    }, [_c('div', {
      staticClass: "onedotitle"
    }, [_vm._v("本阶段相关“一件事”套餐服务")]), _vm._v(" "), _c('div', {
      staticClass: "onedoline"
    }), _vm._v(" "), _c('div', {
      staticClass: "swiper list-swiper"
    }, [_c('div', {
      staticClass: "swiper-wrapper"
    }, _vm._l((item1.chainItemList), function(item2, index2) {
      return _c('div', {
        staticClass: "swiper-slide"
      }, [_c('div', {
        staticClass: "onedo-list"
      }, _vm._l((item2), function(item3, index3) {
        return _c('div', {
          staticClass: "onedo-item"
        }, [_c('div', {
          staticClass: "icon"
        }, [_c('img', {
          attrs: {
            "src": item3.icon,
            "alt": ""
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "text"
        }, [_c('span', [_vm._v(_vm._s(item3.itemName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item3.itemDesc))])]), _vm._v(" "), _c('div', {
          staticClass: "onedo-btn-group"
        }, [_c('div', {
          staticClass: "onedo-btn onedo-btn-active",
          on: {
            "click": function($event) {
              return _vm.openNewPage(item3.zxblUrl)
            }
          }
        }, [_vm._v("在线办理")]), _vm._v(" "), _c('div', {
          staticClass: "onedo-btn onedo-btn-active",
          on: {
            "click": function($event) {
              return _vm.openNewPage(item3.bsznUrl)
            }
          }
        }, [_vm._v("办事指南")])])])
      }), 0)])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "swiper-pagination swiper-pagination1"
    })])]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "cont-theme cont2",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "subject-list"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "list",
    staticStyle: {
      "gap": "128px"
    }
  }, _vm._l((_vm.farenTheme.themeList), function(item, index) {
    return _c('div', {
      class: [index == 0 ? 'item active' : 'item']
    }, [_c('div', {
      staticClass: "title"
    }, [_c('img', {
      attrs: {
        "src": item.icon
      }
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      class: [index == 0 ? 'index index-active' : 'index index-normal']
    }, [_vm._v(_vm._s(index + 1))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "two-cont1"
  }, _vm._l((_vm.farenTheme.themeList), function(item1, index1) {
    return _c('div', {
      staticClass: "cont service-cont"
    }, [(item1.itemList) ? _c('div', {
      staticClass: "list1"
    }, [_c('div', {
      staticClass: "service-list"
    }, [_c('div', {
      staticClass: "swiper list-swiper"
    }, [_c('div', {
      staticClass: "swiper-wrapper"
    }, [_c('div', {
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "service-table"
    }, [_c('div', {
      staticClass: "service-body"
    }, [_vm._l((item1.itemList.slice(_vm.pageSize * (_vm.currentPage_fr[index1] - 1), _vm.pageSize * (_vm.currentPage_fr[index1]))), function(item2, index2) {
      return _c('div', {
        staticClass: "service-item"
      }, [_c('div', [_c('a', {
        attrs: {
          "target": "_blank",
          "href": item2.itemUrl
        }
      }, [_vm._v(_vm._s(index2 + 1) + "    " + _vm._s(item2.itemName))])]), _vm._v(" "), _c('div', {
        class: [item2.lbsjdUrl ? 'lbsjd-active' : 'lbsjd-normal'],
        on: {
          "click": function($event) {
            return _vm.openNewPage(item2.lbsjdUrl)
          }
        }
      }, [_vm._v("\"路标式\"解读")]), _vm._v(" "), _c('div', [_c('a', {
        attrs: {
          "target": "_blank",
          "href": item2.bsznUrl
        }
      }, [_vm._v("办事指南")]), _vm._v(" "), (item2.ermIcon) ? _c('el-popover', {
        attrs: {
          "placement": "bottom",
          "trigger": "hover",
          "visible-arrow": false,
          "popper-options": {
            boundariesElement: 'body',
            removeOnDestroy: true
          }
        }
      }, [_c('div', {
        staticClass: "service-item-ewm"
      }, [_c('img', {
        attrs: {
          "src": item2.ermIcon
        }
      }), _vm._v(" "), _c('div', [_vm._v("使用微信扫码登录")])]), _vm._v(" "), _c('el-button', {
        attrs: {
          "slot": "reference",
          "type": "text",
          "size": "mini"
        },
        slot: "reference"
      }, [_vm._v("手机办理")])], 1) : _c('a', {
        attrs: {
          "target": "_blank",
          "href": item2.sjblUrl
        }
      }, [_vm._v("手机办理")]), _vm._v(" "), _c('a', {
        attrs: {
          "target": "_blank",
          "href": item2.zxblUrl
        }
      }, [_vm._v("在线办理")])], 1)])
    }), _vm._v(" "), (item1.itemList.length > _vm.pageSize) ? _c('el-pagination', {
      attrs: {
        "prev-text": "上一页",
        "next-text": "下一页",
        "total": item1.itemList.length,
        "current-page": _vm.currentPage_fr[index1],
        "page-size": _vm.pageSize,
        "layout": "prev, pager, next"
      },
      on: {
        "current-change": function($event) {
          return _vm.handlePageChange($event, index1, 'fr')
        }
      }
    }) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
      staticClass: "swiper-pagination swiper-pagination1"
    })])]), _vm._v(" "), (item1.chainItemList) ? _c('div', {
      staticClass: "onedo"
    }, [_c('div', {
      staticClass: "onedotitle"
    }, [_vm._v("本阶段相关“一件事”套餐服务")]), _vm._v(" "), _c('div', {
      staticClass: "onedoline"
    }), _vm._v(" "), _c('div', {
      staticClass: "swiper list-swiper"
    }, [_c('div', {
      staticClass: "swiper-wrapper"
    }, _vm._l((item1.chainItemList), function(item2, index2) {
      return _c('div', {
        staticClass: "swiper-slide"
      }, [_c('div', {
        staticClass: "onedo-list"
      }, _vm._l((item2), function(item3, index3) {
        return _c('div', {
          staticClass: "onedo-item"
        }, [_c('div', {
          staticClass: "icon"
        }, [_c('img', {
          attrs: {
            "src": item3.icon,
            "alt": ""
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "text"
        }, [_c('span', [_vm._v(_vm._s(item3.itemName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item3.itemDesc))])]), _vm._v(" "), _c('div', {
          staticClass: "onedo-btn-group"
        }, [_c('div', {
          staticClass: "onedo-btn onedo-btn-active",
          on: {
            "click": function($event) {
              return _vm.openNewPage(item3.zxblUrl)
            }
          }
        }, [_vm._v("在线办理")]), _vm._v(" "), _c('div', {
          staticClass: "onedo-btn onedo-btn-active",
          on: {
            "click": function($event) {
              return _vm.openNewPage(item3.bsznUrl)
            }
          }
        }, [_vm._v("办事指南")])])])
      }), 0)])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "swiper-pagination swiper-pagination1"
    })])]) : _vm._e()]) : _vm._e()])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "outcont feature",
    attrs: {
      "id": "tsq"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title04"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper tese-swiper"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "feature-item",
    on: {
      "click": _vm.zhengceduixian
    }
  }, [_vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "feature-item",
    on: {
      "click": _vm.openDawan
    }
  }, [_vm._m(5), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "feature-item",
    on: {
      "click": _vm.qiyeyiwangtong
    }
  }, [_vm._m(7), _vm._v(" "), _vm._m(8)])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "feature-item",
    on: {
      "click": _vm.yizhaotongxing
    }
  }, [_vm._m(9), _vm._v(" "), _vm._m(10)])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "feature-item",
    on: {
      "click": _vm.gongchengjiansheshenpi
    }
  }, [_vm._m(11), _vm._v(" "), _vm._m(12)])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "feature-item",
    on: {
      "click": _vm.yjswoyaokanOnclick
    }
  }, [_vm._m(13), _vm._v(" "), _vm._m(14)])])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    staticStyle: {
      "right": "-50px",
      "margin-top": "50px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    staticStyle: {
      "left": "-50px",
      "margin-top": "50px"
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-con"
  }, [_c('div', {
    staticClass: "swiper banner-swiper"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "banner-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/banner01.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "banner-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/banner02.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "banner-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/banner03.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "banner-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/banner04.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next-img swiper-button-next4",
    staticStyle: {
      "margin-right": "120px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev-img swiper-button-prev4",
    staticStyle: {
      "margin-left": "120px"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "Zntj"
  }, [_c('div', {
    staticClass: "Zntj-left"
  }, [_c('div', {
    staticClass: "Zntj-title"
  }, [_c('span', [_vm._v("热门")]), _c('span', [_vm._v("事项")]), _c('img', {
    attrs: {
      "src": require("../../static/img/global/zntj-hot.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Zntj-right"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v3/guide-combo/11440106007508683Q444TC06127000"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/global/zntj-hot1.png")
    }
  }), _vm._v("我要换领居民身份证")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508683Q4440106043001"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/global/zntj-hot1.png")
    }
  }), _vm._v("办理往来港澳通行证")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/11440106007508683Q4440106043008"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/global/zntj-hot1.png")
    }
  }), _vm._v("办理往来港澳通行证个人游签注")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/1144010607844173874440125017023"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/global/zntj-hot1.png")
    }
  }), _vm._v("合伙企业设立登记")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/1144010607844173874440125017049"
    }
  }, [_vm._v("内资分公司设立登记")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/1144010607844173874440102008001"
    }
  }, [_vm._v("非学历教育机构设立")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.gdzwfw.gov.cn/portal/v2/guide/1144010607844173874440125017022"
    }
  }, [_vm._v("外商投资的公司分公司设立登记")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-one"
  }, [_c('div', {
    staticClass: "tab-item active"
  }, [_c('div', {
    staticClass: "tab-item-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/person.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-item-text"
  }, [_vm._v("\n              个人事项\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "active-line"
  }, [_c('div', {
    staticClass: "triangle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tab-item"
  }, [_c('div', {
    staticClass: "tab-item-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/legal.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-item-text"
  }, [_vm._v("\n              法人事项\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "active-line"
  }, [_c('div', {
    staticClass: "triangle"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/tese-img1.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("政策兑现平台")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("政策兑现一站式申报服务平台")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/tese-yga.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("粤港澳大湾区服务专区")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("大湾区办事指南解读")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/tese-img3.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("广州市开办企业一网通")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("开办企业一网通")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/tese-img4.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("一照通行联办")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("一照通行联办")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/tese-img5.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("广州市工程建设项目联合\n                              审批平台")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("联合申报、协同审批")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/index/tese-img6.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("一件事我要看")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("一窗受理、一张表单、一次办理，为企业提供主题式、套餐式集成服务。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16b57602"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 1068
// module chunks = 0